
import { useEffect, useState, } from 'react';
import {
    Box,
    makeStyles, FormControl,
    FormGroup, FormControlLabel, Checkbox
} from '@material-ui/core';
//Helpers.
import { blueBar } from '../../../helpers/common'

let scrollsSettings = {
    overflow: 'scroll',
    overflowX: 'hidden',
};
let webkitScrollbar = {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#beb1b18f',
    color: 'red',
    width: '9px',
};
let webkitscrollbarTrack = {
    background: '#dfdfe957',
};

const useStyles = makeStyles(theme => ({
    root: {
        ...scrollsSettings,
        height: '600px',
        '@media (max-width: 920px)': {
            height: '70%',
        },
        '&::-webkit-scrollbar': {
            //son los estilos de las barras scroll en una variable.
            ...webkitScrollbar,
        },
        '&::-webkit-scrollbar-track': {
            //son los estilos de las barras scroll en una variable.
            ...webkitscrollbarTrack,
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.primary.main,
        },
        '& .MuiGrid-root': {
            padding: theme.spacing(1),
        },
        '& .MuiStepper-root': {
            padding: '1px',
        },
        '& .MuiFormControlLabel-root': {
            marginRight: theme.spacing(0.5),
        },
    },
}));

const TwdayFilterOptions = ({ varState, setVarState }) => {
    const blueLine = blueBar()
    const classes = useStyles();
    //Estado de el filtro.
    const [selectedDays, setSelectedDays] = useState([]);

    useEffect(() => {
        if (varState?.a?.d) {
            setSelectedDays(mergeData(varState?.a?.d))
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setVarState({
            ...varState,
            a: formatDays(selectedDays)
        })
        // eslint-disable-next-line
    }, [selectedDays])

    function mergeData(formato) {
        const numerosADias = {
            1: 'lu',
            2: 'ma',
            3: 'mi',
            4: 'ju',
            5: 'vi',
            6: 'sa',
            7: 'do'
        };
        let dias = [];
        const partes = formato.split(',');
        for (let parte of partes) {
            if (parte.includes('-')) {
                const [inicio, fin] = parte.split('-').map(Number);
                for (let i = inicio; i <= fin; i++) {
                    dias.push(numerosADias[i]);
                }
            } else {
                dias.push(numerosADias[Number(parte)]);
            }
        }
        return dias;
    }

    function formatDays(diasAbrev) {
        if (diasAbrev.length > 0) {
            const diasNumeros = {
                'lu': 1,
                'ma': 2,
                'mi': 3,
                'ju': 4,
                'vi': 5,
                'sa': 6,
                'do': 7
            };
            // Convertir abreviaciones a números y ordenarlos
            const dias = diasAbrev.map(d => diasNumeros[d.toLowerCase()]).sort((a, b) => a - b);
            let resultado = [];
            let inicio = dias[0];
            let anterior = dias[0];
            for (let i = 1; i < dias.length; i++) {
                if (dias[i] === anterior + 1) {
                    anterior = dias[i];
                } else {
                    if (inicio === anterior) {
                        resultado.push(`${inicio}`);
                    } else {
                        resultado.push(`${inicio}-${anterior}`);
                    }
                    inicio = dias[i];
                    anterior = dias[i];
                }
            }
            // Agregar el último rango o día
            if (inicio === anterior) {
                resultado.push(`${inicio}`);
            }
            else {
                resultado.push(`${inicio}-${anterior}`);
            }
            return { d: resultado.join(',') }
        }
        return { d: '' }
    }

    const handleTimeslots = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            // Si se selecciona, agregamos el día al array
            setSelectedDays([...selectedDays, value]);
        } else {
            // Si se deselecciona, eliminamos el día del array
            setSelectedDays(selectedDays.filter(day => day !== value));
        }
    }

    return (
        <Box>

            {blueLine}
            <Box width={'100%'} >
                <Box className={classes.devicesLabel}>
                    Franja horaria
                </Box>

                <Box >
                    <FormControl disabled={false}>
                        <FormGroup row>
                            {['lu', 'ma', 'mi', 'ju', 'vi', 'sa', 'do'].map(elem => (
                                <FormControlLabel
                                    style={{ marginRight: '0px', marginLeft: '0px' }}
                                    key={elem}
                                    control={
                                        <Checkbox
                                            value={elem}
                                            checked={selectedDays.includes(elem)}
                                            onChange={handleTimeslots}
                                            color="primary"
                                        />
                                    }
                                    label={elem}
                                    labelPlacement="start"
                                />
                            ))}
                        </FormGroup>
                    </FormControl>
                </Box>

            </Box>
        </Box >
    )
}
export default TwdayFilterOptions





